import transliterateToAscii from "./transliterateToAscii";

export default function rename({ pattern, isbn, title, seq, total, suffix }) {
	return pattern.replace(
		/ISBN|SEQPAD|SEQ|TOTAL_NO_PAD|TOTAL|SUFFIX|CLEANTITLE_CUSTOM_ONE|CLEANTITLE|SPACELESSSLUG|SLUG|TITLE|DATE|TIME/g,
		(matched) =>
			({
				ISBN: isbn,
				SEQPAD: total > 1 ? (seq + "").padStart((total + "").length, 0) : "",
				SEQ: seq,
				TOTAL_NO_PAD: total,
				TOTAL: (total + "").padStart(3, 0),
				SUFFIX: suffix,
				CLEANTITLE: title && transliterateToAscii(title),
				CLEANTITLE_CUSTOM_ONE:
					title &&
					transliterateToAscii(title, {
						keepSpaces: false,
						translateCharactersBefore: [["&", "-"]],
						titleCase: true,
					}),
				SLUG:
					title &&
					transliterateToAscii(title, { translateCharactersBefore: [["&", "and"]] }).replace(/ /g, "_"),
				SPACELESSSLUG:
					title &&
					transliterateToAscii(title, {
						keepSpaces: false,
						titleCase: true,
						translateCharactersBefore: [["&", "and"]],
					}),
				TITLE: title,
				DATE: (() => {
					const d = new Date();
					var mm = d.getMonth() + 1;
					var dd = d.getDate();

					return [d.getFullYear(), (mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join("");
				})(),
				TIME: (() => {
					const d = new Date();
					var hh = d.getHours();
					var mm = d.getMinutes();
					var ss = d.getSeconds();

					return [(hh > 9 ? "" : "0") + hh, (mm > 9 ? "" : "0") + mm, (ss > 9 ? "" : "0") + ss].join("");
				})(),
			}[matched]),
	);
}
